<div *ngIf="claims">
  <router-outlet></router-outlet>
</div>
